/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"
import { theme } from "./theme"

const baseHeader = css`
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #1a1a1a;
  margin-top: 0;
  margin-bottom: 0;
`
export const commonStyle = css`
  h1.page-title {
    ${baseHeader}
    font-size: 32px;
  }

  h2.page-subtitle {
    ${baseHeader}
    font-size: 18px;
  }

  .page-content {
    padding: 0 32px 32px 32px;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 900px;
  }

  .input-clear-icon {
    cursor: pointer;
  }

  /* For sortable drawer */
  .sortable-list {
    z-index: 1000;
  }

  .change-store-status-button {
    text-align: right;
  }
`

export const headerActions = css`
  display: flex;
  flex-direction: row;
  & > :not(:last-child) {
    margin-right: 8px;
  }
`

// card styles

export const cardStyle = css`
  border: 1px solid ${theme.colors.border};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 20px;

  &.clickable {
    cursor: pointer;
    :hover {
      box-shadow: ${theme.shadow.default};
    }
  }

  &.disabled {
    background-color: #f5f5f5;
    pointer-events: none;
  }
`

// stepper styles

export const customStepper = css`
  .ant-steps-item {
    background: rgba(5, 149, 218, 0.1);
    cursor: pointer;
    padding: 0 64px;
    height: 65px;
    display: flex;
    align-items: center;
    flex: none;
    margin-right: -25px !important;
    &:first-child {
      padding: 0 64px 0 24px;
      clip-path: polygon(
        0 0,
        calc(100% - 35px) 0%,
        100% 50%,
        calc(100% - 35px) 100%,
        0 100%,
        0 50%
      );
    }
    &:not(:first-child) {
      clip-path: polygon(
        0 0,
        calc(100% - 35px) 0%,
        100% 50%,
        calc(100% - 35px) 100%,
        0 100%,
        35px 50%
      );
    }
    &:last-child {
      padding: 0 24px 0 64px;
      clip-path: polygon(0 0, 100% 0%, 100% 50%, 100% 100%, 0 100%, 35px 50%);
    }
  }

  .ant-steps-item-wait {
    background: #f8f8f8;
    cursor: not-allowed;
    pointer-events: none;
  }

  .ant-steps-item > .ant-steps-item-content > .ant-steps-item-title {
    color: #0595da;
    padding: 0;
  }

  .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title {
    color: #979797;
  }

  .ant-steps-item > .ant-steps-item-icon {
    border: none;
    background: #0595da;
    .anticon-check:before {
      color: #ffffff;
    }
  }

  .ant-steps-item-wait > .ant-steps-item-icon {
    background: #e4e4e4;
  }

  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: #979797;
  }

  .ant-steps-item-title {
    font-weight: 500;
    &:after {
      content: none;
    }
  }
`
